const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-badge ---
let __fez_component_0;
{

__fez_component_0 = class {
  NAME = 'span'

  PROPS = {
    label: String,
    tone: { type: String, default: 'neutral', enum: ['neutral', 'accent', 'success', 'warning', 'danger', 'count'] },
    icon: String,
  }

  CSS = `:fez {
display:inline-flex;vertical-align:middle;.badge{display:inline-flex;align-items:center;gap:var(--space-1);height:22px;padding:0 var(--space-2);border-radius:var(--radius-full);font-size:var(--text-xs);font-weight:var(--weight-semibold);line-height:1;white-space:nowrap}.neutral{background:var(--color-bg-hover);color:var(--color-text-muted)}.accent{background:var(--color-accent-soft);color:var(--color-link)}.success{background:var(--color-success-soft);color:var(--color-success)}.warning{background:var(--color-warning-soft);color:var(--color-warning)}.danger{background:var(--color-danger-soft);color:var(--color-danger)}.count{min-width:20px;height:20px;justify-content:center;padding:0 6px;background:var(--color-unread);color:var(--color-text-inverse);font-weight:var(--weight-bold)}
}`

  HTML = `{#if props.label && props.label !== '0'}
<span class="badge {props.tone}">
{#if props.icon}
<ui-icon name={props.icon} size="12"></ui-icon>
{/if}
{props.label}
</span>
{/if}`
};
}

Fez('ui-badge', __fez_component_0);

export default __fez_component_0;
